
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";

export default function ColorCheckbox({ color = "#000", ...props }) {
    const isLight = ["#fff", "#ffffff", "#f9f9f9", "#fafafa", "#fcfcfc"].includes(
        color.toLowerCase()
    );

    return (
        <Checkbox
            {...props}
            disableRipple
            icon={
                <Box
                    sx={{
                        width: 18,
                        height: 18,
                        backgroundColor: color,
                        border: isLight ? "1px solid #BEBEBE" : "1px solid transparent",
                    }}
                />
            }
            checkedIcon={
                <Box
                    sx={{
                        width: 18,
                        height: 18,
                        backgroundColor: color,
                        border: isLight ? "1.5px solid #111" : "1.5px solid #111",
                        boxShadow: "inset 0 0 0 2px #FFFFFF",
                    }}
                />
            }
            sx={{
                p: 0,
                m: 0,
                "&:hover": { backgroundColor: "transparent" },
                "& .MuiSvgIcon-root": { borderRadius: 0 },
            }}
        />
    );
}
